import { render, staticRenderFns } from "./PractitionerAnnualReturnsDetails.vue?vue&type=template&id=aafa6b02&scoped=true&"
import script from "./PractitionerAnnualReturnsDetails.vue?vue&type=script&lang=js&"
export * from "./PractitionerAnnualReturnsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafa6b02",
  null
  
)

export default component.exports